import { $Qll } from "../utils/query-selector";
import { createInterception } from "../utils/script-defer";

const cardVisible = (target, allTargets) => {
  allTargets.forEach((card) => card.classList.remove('visible'))
  return target.classList.add('visible')
}

export const sliderVisibleCard = () => {
  const cards = $Qll('.card-content-js');

  cards.forEach((card) => {
    createInterception(
      card,
      () => cardVisible(card, cards),
      { rootMargin: "0px", threshold: 1.0 },
    )
  })
};
